import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createNewRecipe } from '../../actions/adminRecipes';
import RecipeForm from './RecipeForm';

const NewRecipe = ({ adminRecipes, createNewRecipe, history }: any) => {
  const [values, setValues] = useState({
    title: '',
    description: '',
    prepTime: '',
    totalTime: '',
    caloriesPerServing: '',
    servings: '',
  });
  const [recipeImage, setRecipeImage] = useState<any>(null);
  const [imageUrl, setImageUrl] = useState('');
  const [ingredients, setIngredients] = useState(['']);
  const [directions, setDirections] = useState(['']);
  const [errors, setErrors] = useState<any>({});
  const [showSuccess, setShowSuccess] = useState(false);

  const prevRef = useRef(adminRecipes);

  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = adminRecipes;

    if (adminRecipes.errors !== prev.errors) setErrors(adminRecipes.errors);

    if (adminRecipes.newRecipe !== prev.newRecipe && adminRecipes.newRecipe) {
      setShowSuccess(true);
      setValues({ title: '', description: '', prepTime: '', totalTime: '', caloriesPerServing: '', servings: '' });
      setRecipeImage(null);
      setImageUrl('');
      setIngredients(['']);
      setDirections(['']);
      setErrors({});
    }
  }, [adminRecipes]);

  const onChange = (e: any) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };
    if (newErrors[name]) delete newErrors[name];
    let parsed: any = value;
    if ((name === 'caloriesPerServing' || name === 'servings') && value !== '') parsed = parseFloat(value);
    setValues((prev) => ({ ...prev, [name]: parsed }));
    setErrors(newErrors);
  };

  const onImageSelect = (e: any) => {
    if (e.target.name !== 'recipeImage') return;
    const newErrors = { ...errors };
    delete newErrors.recipeImage;
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setRecipeImage(file);
      setImageUrl(reader.result as string);
      setErrors(newErrors);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    if (recipeImage) formData.append('recipeImage', recipeImage);
    if (values.title) formData.append('title', values.title);
    if (values.description) formData.append('description', values.description);
    if (values.prepTime) formData.append('prepTime', values.prepTime);
    if (values.totalTime) formData.append('totalTime', values.totalTime);
    if (values.caloriesPerServing) formData.append('caloriesPerServing', String(values.caloriesPerServing));
    if (values.servings) formData.append('servings', String(values.servings));
    formData.append('ingredients', JSON.stringify(ingredients));
    formData.append('directions', JSON.stringify(directions));
    createNewRecipe(formData);
  };

  return (
    <>
      <Helmet>
        <title>New Recipe - Frozberries Victoria</title>
      </Helmet>

      <div className="admin-card" style={{ marginBottom: 0 }}>
        <div className="admin-card-header">
          <p className="admin-card-title">New Recipe</p>
          {showSuccess && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span className="status-badge confirmed" style={{ fontSize: '0.78rem' }}>Created!</span>
              {adminRecipes.newRecipe && (
                <span
                  style={{ fontSize: '0.78rem', color: '#ec174f', cursor: 'pointer' }}
                  onClick={() =>
                    history.push(`/recipes/${adminRecipes.newRecipe.title.replace(/[^A-Z0-9]+/gi, '-')}/${adminRecipes.newRecipe._id}`)
                  }
                >
                  View recipe →
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      <RecipeForm
        values={values}
        errors={errors}
        imageUrl={imageUrl}
        ingredients={ingredients}
        directions={directions}
        loading={adminRecipes.loading}
        submitLabel="Create Recipe"
        onChange={onChange}
        onImageSelect={onImageSelect}
        onSubmit={handleSubmit}
        onBack={() => history.push('/adminpanel/recipes')}
        onIngredientsChange={setIngredients}
        onDirectionsChange={setDirections}
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  adminRecipes: state.adminRecipes,
});

export default connect(mapStateToProps, { createNewRecipe })(NewRecipe);
